import { createContext } from 'react';
import { ChartActions, ChartStateType } from './chartTypes';
import { ContextWrapper } from '../../config/constants';

const chartContext = createContext({} as ContextWrapper<ChartStateType, ChartActions>);
chartContext.displayName = 'ChartContext';

export default chartContext;
